export default __webpack_public_path__ + "static/media/Crimson Death.4cf4d6b6.jpg";